import { http } from '@/lib/apiClient';
import type {
  BackupJobConRelazioni,
  BackupJobFilters,
  BackupPendingGroup,
  BackupPendingGroupFilters,
  MappaBackupPendingInput,
  Paginated,
  ScartaBackupPendingInput,
  UUID,
} from '@/types';

const BASE = '/backup/jobs';
const PENDING = '/backup/pending';

export const backupService = {
  list(filters: BackupJobFilters = {}): Promise<Paginated<BackupJobConRelazioni>> {
    return http.get<Paginated<BackupJobConRelazioni>>(BASE, { params: filters });
  },

  /** Detail response also carries `raw_body`, omitted from list payloads. */
  get(id: UUID): Promise<BackupJobConRelazioni> {
    return http.get<BackupJobConRelazioni>(`${BASE}/${id}`);
  },

  /** Latest N jobs – used by the dashboard widget and the AI assistant context. */
  latest(limit = 5, clienteId?: UUID): Promise<BackupJobConRelazioni[]> {
    return http.get<BackupJobConRelazioni[]>(`${BASE}/latest`, { params: { limit, clienteId } });
  },

  pendingCount(): Promise<{ count: number }> {
    return http.get<{ count: number }>(`${PENDING}/count`);
  },

  pendingGroups(filters: BackupPendingGroupFilters = {}): Promise<Paginated<BackupPendingGroup>> {
    return http.get<Paginated<BackupPendingGroup>>(`${PENDING}/groups`, { params: filters });
  },

  mappaBatch(input: MappaBackupPendingInput): Promise<{ promoted: number; macchina_id: UUID }> {
    return http.post(`${PENDING}/mappa-batch`, input);
  },

  scartaBatch(input: ScartaBackupPendingInput): Promise<{ discarded: number }> {
    return http.post(`${PENDING}/scarta-batch`, input);
  },

  riprocessa(): Promise<{ scanned: number; promoted: number; unresolved: number; remaining: number }> {
    return http.post(`${PENDING}/riprocessa`);
  },
};
